export const getFilteredTags = (activeTags: string[], subscriptions) =>
  subscriptions.filter((subscription) => subscription.tags.some((tag) => activeTags.includes(tag)));
